import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalCommandNotAllowedDuringCallError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalCommandNotAllowedDuringCallError';
  }
}
